const ONE_HOUR = 1000 * 60 * 60;

class RecoverVersion {

    constructor() {
    }

    static getSearchKey() {
        return 'location';
    }

    static getTierOptions(translateFilter) {
        return [
            { label: !translateFilter ? 'ARCHIVE' : translateFilter('default.tier.option.archive'), value: 'ARCHIVE', key: 'ARCHIVE' },
            { label: !translateFilter ? 'BACKUP' : translateFilter('default.tier.option.backup'), value: 'BACKUP', key: 'BACKUP' },
            { label: !translateFilter ? 'COPY' : translateFilter('default.tier.option.copy'), value: 'COPY', key: 'COPY' },
            { label: !translateFilter ? 'SNAPSHOT' : translateFilter('default.tier.option.snapshot'), value: 'SNAPSHOT', key: 'SNAPSHOT' }
        ];
    }

    static getTimeOptions(translateFilter) {
        return [
            { name: !translateFilter ? 'Last 1 hour' : translateFilter('event.filters.radio.last.1hour'), value: (ONE_HOUR).toString() },
            { name: !translateFilter ? 'Last 24 hours' : translateFilter('event.filters.radio.last.24hour'), value: (ONE_HOUR * 24).toString() },
            { name: !translateFilter ? 'Last week' : translateFilter('event.filters.radio.last.week'), value: (ONE_HOUR * 24 * 7).toString() },
        ];
    }

    static getCompliancyOptions(translateFilter) {
        return [
            { label: !translateFilter ? 'Success' : translateFilter('default.severitylevel.success'), value: 'GREEN' },
            { label: !translateFilter ? 'Failure' : translateFilter('default.severitylevel.failure'), value: 'RED' },
            { label: !translateFilter ? 'Undefined' : translateFilter('default.severitylevel.undefined'), value: 'GREY' }
        ];
    }

    static getStatusOptions(translateFilter) {
        return [
            { label: !translateFilter ? 'Success' : translateFilter('default.severitylevel.success'), value: 'OK' },
            { label: !translateFilter ? 'Failure' : translateFilter('default.severitylevel.failure'), value: 'FATAL||ERROR||SKIPPED' },
            { label: !translateFilter ? 'Expired' : translateFilter('default.severitylevel.expired'), value: 'EXPIRED' },
            { label: !translateFilter ? 'Warning' : translateFilter('default.severitylevel.warning'), value: 'WARNING' }
        ];
    }

    static fromRaw(raw) {
        let rv = new RecoverVersion();
        rv.uuid = raw.uuid;
        rv.timeOfLastBackupInSeconds = raw.timeOfLastBackupInSeconds;
        rv.backupRpo = raw.backupRpo;
        rv.taskDurationTime = raw.taskDurationTime / 1000;
        rv.taskId = raw.taskUuid;
        rv.taskName = raw.taskName;
        rv.taskStatus = raw.taskStatus;
        rv.taskType = raw.taskType;
        rv.backupTiers = raw.backupTiers;
        rv.restorePointInMillis = raw.creationTimestamp;
        rv.compliancy = raw.compliancy;
        rv.virtualMachinesubscriptionId = raw.virtualMachineUuid;
        rv.vmName = raw.virtualMachineName;
        rv.targetName = raw.backupTargetName;
        rv.targetsubscriptionId = raw.targetsubscriptionId;
        rv.lastRestoreStatus = raw.lastRestoreStatus;
        rv.lastRestoreTaskUuid = raw.lastRestoreTaskUuid;
        rv.securityType = raw.securityType;
        rv.restorePointStatus = raw.restorePointStatus;
        rv.creationTimestamp = raw.creationTimestamp;
        rv.disks = raw.disks;
        rv.catalogs = raw.disksCatalogs;
        rv.backupSizeInBytes = raw.backupSizeInBytes;
        rv.catalogsAvailable = raw.catalogsAvailable;
        rv.catalogStatus = raw.catalogStatus;
        rv.snapshotsOnCloud = raw.snapshotOnCloud;
        rv.backupOnTarget = raw.backupToTarget;
        rv.copy = raw.copy;
        rv.archiving = raw.archiving;
        rv.restoreAvailable = raw.restoreAvailable;
        rv.restoreFlrAvailable = raw.restoreFlrAvailable;
        rv.expireAvailable = raw.expireAvailable;
        rv.backupStatus = raw.backupState;
        return rv;
    }

    toRaw() {
        return {
            uuid: this.uuid,
        };
    }
}

module.exports = RecoverVersion;



// WEBPACK FOOTER //
// ./src/azurebackup/model/RecoverVersion.js